<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import config from 'src/config'
import authHelper from 'api/auth/helper'

export default {
  name: 'selected-inventory',
  props: {
    value: {
      type: Number,
      default: 1,
    },
    inventory: {
      type: Object,
      required: true,
    },
    disableInlineCheckout: {
      type: Boolean,
      default: false,
    },
    checkoutUrl: {
      type: String,
    },
    eventId: {
      type: String,
    },
    theme: {
      type: String,
      default: 'theme-light',
    },
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      //
      attributionId: (state) => state.config.attributionId,
      affiliateId: (state) => state.config.affiliateId,
      trackingId: (state) => state.config.trackingId,
      client: (state) => state.config.client,
    }),
    bookingUrl() {
      const quantity = this.inventoryQuantity || 1

      const checkoutUrl = this.checkoutUrl && this.checkoutUrl.trim && this.checkoutUrl.trim() !== '' ? this.checkoutUrl : `${config.TABLELIST_WEBSITE_URL}/buy`

      let url = `${checkoutUrl}?inventory=${this.inventory.id}&quantity=${quantity}&venueId=${this.venue.id}`

      if (authHelper.getAuthToken()) {
        url += `&authToken=${authHelper.getAuthToken()}`
      } else {
        url += `&prospectToken=${authHelper.getProspectToken()}`
      }

      if (this.affiliateId) {
        url += `&affiliateId=${this.affiliateId}`
      }

      if (this.trackingId) {
        url += `&trackingId=${this.trackingId}`
      }

      if (this.eventId) {
        url += `&eventId=${this.eventId}`
      }

      //TODO: push this into Vuex store called 'config' or 'settings'
      if (this.attributionId) {
        url += `&attributionId=${this.attributionId}`
      }

      //TODO: push this into Vuex store called 'config' or 'settings'
      url += `&client=${this.client}`

      return url
    },
    subtotal() {
      return ((this.inventory.price || 0) * (this.inventoryQuantity || 1)).toFixed(2)
    },
  },
  data() {
    return {
      submittingBookingForm: false,
      inventoryQuantity: 1,
      ticketQuantityError: false,
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    bookingFormSubmitted() {
      this.submittingBookingForm = true

      this.$emit('bookingFormSubmitted')

      setTimeout(() => {
        this.submittingBookingForm = false
      }, 1000)
    },
    checkout() {
      this.$emit('checkout')
    },
    getTicketSelectorQuantity() {
      if (!this.inventory) {
        return []
      }

      const min = this.inventory.quantityMin || 0
      let max = this.inventory.quantityMax || 10

      if (max > 100) {
        max = 100
      }

      const quantities = []

      for (let i = min; i <= max; i++) { //eslint-disable-line
        quantities.push(i)
      }

      return quantities
    },
    isValid() {
      this.ticketQuantityError = false

      if (this.inventory.quantityMin > 0 && this.inventoryQuantity < this.inventory.quantityMin) {
        this.ticketQuantityError = true
        return false
      } else if (this.inventory.quantityMax > 0 && this.inventoryQuantity > this.inventory.quantityMax) {
        this.ticketQuantityError = true
        return false
      }

      return true
    },
    onInventoryQuantityChanged() {
      this.$emit('input', this.inventoryQuantity)
    },
  },
  mounted() {
    this.inventoryQuantity = this.value
  },
}
</script>



// WEBPACK FOOTER //
// src/components/SelectedInventory/index.vue